import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import type { RecipientResponse } from '@shared/api';
import { Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

interface RecipientDetailsProps {
  isShowRecipientDetails?: boolean;
  onToggle: () => void;
  recipient: RecipientResponse;
}

export const RecipientDetails = (props: RecipientDetailsProps) => {
  const { t } = useTranslation('payments');

  const details = useMemo(
    () =>
      [
        { label: t('recipient.details.fields.iban'), value: props.recipient.iban },
        { label: t('recipient.details.fields.bankName'), value: props.recipient.bankName },
        { label: t('recipient.details.fields.bicSwiftCode'), value: props.recipient.bic },
        { label: t('recipient.details.fields.firstName'), value: props.recipient.firstName },
        { label: t('recipient.details.fields.lastName'), value: props.recipient.lastName },
        { label: t('recipient.details.fields.companyName'), value: props.recipient.companyName },
      ].filter((item) => item.value),
    [t, props.recipient],
  );
  return (
    <div className='mt-3 flex w-full flex-col'>
      <div className='flex cursor-pointer gap-2' onClick={props.onToggle}>
        <Text>{t('recipient.details.title')}</Text>
        <Icon icon={<ChevronIcon />} className={cn('-rotate-90 transition duration-200', props.isShowRecipientDetails && 'rotate-90')} />
      </div>
      {props.isShowRecipientDetails && (
        <div className={cn('mt-3 flex gap-10', 'max-[1024px]:flex-wrap')}>
          {details.map((item, idx) => (
            <div key={idx} className='flex flex-col'>
              <Text size='sm' color='secondary'>
                {item.label}
              </Text>
              <Text weight='semibold' size='sm'>
                {item.value}
              </Text>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
